import { CartDetail } from '@/modules/cart/types';
import { Mutations } from 'vuex-smart-module';
import { default_cart_detail } from '@/modules/cart/services';
import CartDetailState from './state';

export default class CartDetailMutations extends Mutations<CartDetailState> {
  SET_CURRENT_CART(cart: CartDetail) {
    this.state.current_cart = cart;
  }

  CLEAR_CURRENT_CART() {
    this.state.current_cart = default_cart_detail();
  }
}
